<section-anchor [valid]="valid" [touched]="touched"></section-anchor>
<h3 class="body-3-bold" [class.compact]="compact">
  <ng-content></ng-content>
  @if (optional) {
    <span class="optional">
      {{ optionalText || '(optional)' }}
    </span>
  }
</h3>
